var map = {
	"./add.svg": 54984,
	"./bank.svg": 74985,
	"./bundle-default.svg": 36155,
	"./bundle-hover.svg": 13258,
	"./bundle-selected.svg": 54975,
	"./credit-card.svg": 33283,
	"./delete.svg": 61954,
	"./down.svg": 99995,
	"./practice-product-default.svg": 58938,
	"./practice-product-hover.svg": 52679,
	"./practice-product-selected.svg": 32020,
	"./quick-bill-default.svg": 57306,
	"./quick-bill-hover.svg": 83879,
	"./quick-bill-selected.svg": 69492,
	"./up.svg": 73204,
	"./vibrant-product-default.svg": 77733,
	"./vibrant-product-hover.svg": 65756,
	"./vibrant-product-selected.svg": 23233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6603;